export default {
    de: {
        messageBoxTitle: 'Vielen Dank für Ihr Vertrauen in smava!',
        messageBoxContent: 'Ihre Bau-/Immobilienfinanzierungsanfrage ist bei uns eingegangen.',
        listTitle: 'Die weiteren Schritte:',
        personalAdvicePointTitle: 'Persönliche Beratung',
        personalAdvicePointDescription: 'Ihr persönlicher Spezialist für Bau-/Immobilienfinanzierungsanfrage meldet sich telefonisch bei Ihnen, um die Details Ihrer Anfrage zu besprechen.',
        financingOfferPointTitle: 'Ihr Finanzierungsangebot',
        financingOfferPointDescription: 'Auf Basis Ihrer Wünsche und Anforderungen ermitteln wir für Sie ein individuelles Finanzierungsangebot.',
    },
};
